angular
        .module('control.searchDropdown')
        .constant('searchDropdownConst', {
                POLICY_DROPDOWN_PLACEHOLDER: 'Select a policy',
                CLAIM_DROPDOWN_PLACEHOLDER: 'Select a claim',
                NO_ACTIVE_POLICY_MESSAGE: 'No active policy attached to your account',
                NO_POLICY_MESSAGE: 'No policy attached to your account',
                SEARCH_DEPLAY: 1000
        });